import getPathsEditingSelector from 'modules/editing/selectors/get-paths'
import { EDITING_DOMAIN } from 'modules/editing/constants'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import { discardLegacyReduxAction } from 'modules/redux/actions/legacy/discard'

/**
 * Adds the editing path.
 * @param  {String|Number} path
 * @returns {Function}
 */
function addEditingAction (path) {
  return (dispatch, getState) => {
    // If the `path` is already there, noop
    let paths = getPathsEditingSelector()(getState())
    if (paths.includes(path)) {
      return
    }
    // Add the path to the `paths`
    paths = [
      ...paths,
      path
    ]
    dispatch(
      updateLegacyReduxAction({
        path: EDITING_DOMAIN,
        value: { paths }
      })
    )
  }
}

/**
 * Removes the path from paths and
 * discards the changes made to the instance.
 *
 * @param  {string} path
 * @param  {Object} [options={}]
 *         {boolean} shouldNotDiscard
 * @returns {Function}
 */
function removeEditingAction (path, options = {}) {
  return (dispatch, getState) => {
    // If the `path` is not in the `paths`, noop
    let paths = getPathsEditingSelector()(getState())
    if (!paths.includes(path)) {
      return
    }
    // Remove the `path` from the `paths`
    paths = paths.filter(p => p !== path)
    dispatch(
      updateLegacyReduxAction({
        path: EDITING_DOMAIN,
        value: { paths }
      })
    )
    // Discard the changes made to the instance
    if (!options.shouldNotDiscard) {
      dispatch(
        discardLegacyReduxAction(path)
      )
    }
  }
}

/**
 * Resets the domain.
 * @returns {Function}
 */
function resetEditingAction () {
  return (dispatch, getState) => {
    // If the `paths` are already empty, noop
    const paths = getPathsEditingSelector()(getState())
    if (!paths.length) {
      return
    }
    // Remove each path from the domain
    paths.forEach(path => dispatch(removeEditingAction(path)))
  }
}

export {
  addEditingAction,
  removeEditingAction,
  resetEditingAction
}
